<template>
	<div>
		<el-table :data="tableData" style="width: 100%" class="mb-3" size="mini" v-loading="loading">
			<el-table-column label="List user in group">
				<template slot-scope="scope">
					<div class="d-flex align-items-center">
						<b-avatar
							style="margin-left:unset !important; margin-right:unset !important; width: 32px !important; height: 32px !important;"
							:src="'#'" :text="_gHlp.formatInitials(scope.row.name)">
						</b-avatar>
						<strong class="ml-3">{{ scope.row.name }}</strong>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="Join date" width="180">
				<template slot-scope="scope">
					<p>{{ scope.row.join_date }}</p>
				</template>
			</el-table-column>
			<el-table-column width="80">
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.is_admin == 0 ? 'Set As Admin' : 'Unset From Admin'">
						<el-button size="mini" :type="scope.row.is_admin == 0 ? 'default' : 'success'" icon="el-icon-user" circle
							@click="setAsAdmin(scope.row, ((scope.row.is_admin == 0) ? 1 : 0))"></el-button>
					</el-tooltip>
					<el-tooltip :content="'Remove From Group'" v-if="showRemoveBtn(scope.row)">
						<el-button size="mini" type="danger" icon="el-icon-close" circle @click="removeUser(scope.row)"></el-button>
					</el-tooltip>
				</template>
			</el-table-column>
		</el-table>

		<b-form-group>
			<div class="d-flex align-items-center">
				<el-select v-model="selected_user_id" filterable placeholder="Select user for add to group">
					<el-option-group
						v-for="(group,index) in option_user_list"
						:key="index"
						:label="group.group_name">
						<el-option
							v-for="(item, idx) in group.group_items"
							:key="idx"
							:label="item.name"
							:value="item.id">
					</el-option>
					</el-option-group>
				</el-select>
				<el-button type="primary" icon="el-icon-plus" @click="addUser()"> Add</el-button>
			</div>
		</b-form-group>
	</div>
</template>
<script>
import { Select, Option, OptionGroup, Table, TableColumn, Button, Tooltip } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import _ from 'lodash'

export default {
	props: {
		currentGroup: Object,
		initMember: Boolean,
		groupType: String
	},
	components: {
		[Button.name]: Button,
		[OptionGroup.name]: OptionGroup,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			group: {},
			group_type: 'internal',
			selected_user_id: null,
			tableData: [],
			defaultAdminUserIds: [],
			loading: false,

		}
	},
	created() {
		this.tableData = []
		this.populateDefaultAdminUserIds()
	},
	watch: {
		currentGroup: {
			handler(newVal) {
				this.initGroup(newVal)
			},
			immediate: true
		},
		initMember: {
			handler(newVal) {
				this.initGroup(this.currentGroup)
			},
			immediate: true
		},
		groupType: {
			handler(newVal) {
				this.group_type = !_gHlp.isEmpty(newVal) ? newVal : 'internal'
			},
			immediate: true
		}
	},
	computed: {
		...mapState(useMessagingStore, ['available_user_list']),
		option_user_list() {
			const userIds = !_gHlp.isEmpty(this.tableData) ? this.tableData.map(o => o.id) : [];
			userIds.push(_gAuth.activeUserId())

			const removeUserIds = !_gAuth.appIsDemo() ? [649, 646, 545] : [540];
			const filteredUserList = this.available_user_list.filter(o => !removeUserIds.includes(o.id));

			let items = [];
			console.log(this.group_type);
			if(this.group_type == 'internal'){
				items = filteredUserList.filter(o => (!userIds.includes(o.id) && (o.application_code == _gAuth.appCode())))
			}else{
				items = filteredUserList.filter(o => !userIds.includes(o.id))
			}
			let grouped = _.groupBy(items,'corporate_name');
			return Object.keys(grouped).map(label => ({
					group_name: label,
					group_items: grouped[label]
			}));
		}
	},
	methods: {
		...mapActions(useAccessControlStore, ['getUser']),
		async initGroup(newVal) {
			if (!_gHlp.isEmpty(newVal)) {
					this.group = newVal
				this.tableData = []
					this.tableData = newVal.group_participants.map((o) => {
						return {
							id: o.participant_user_id,
							name: o.participant_fullname,
							join_date: o.gmp_join_date,
							is_admin: o.gmp_is_admin
						}
					})
				} else {
					this.loading = true;
					this.tableData = []
					if (_gHlp.isEmpty(this.defaultAdminUserIds)) {
					await this.populateDefaultAdminUserIds()
					}
					for (let i = 0; i < this.defaultAdminUserIds.length; i++) {
						const id = this.defaultAdminUserIds[i];
						let usr = await this.getUser(id);
						if (!_gHlp.isEmpty(usr)) {
							this.tableData.push({
								id: usr.id,
								name: usr.name,
								join_date: null,
								is_admin: 1
							});
						}
					}
					this.loading = false;
				}
			this.pushToParent()
			},
		addUser() {
			if (_gHlp.isEmpty(this.selected_user_id)) {
				_gNotif.notifyError('Please select user first')
				return false
			}

			let id = this.selected_user_id
			let user = this.available_user_list.find(o => o.id == id)
			if (!_gHlp.isEmpty(user)) {
				this.tableData.push({
					id: user.id,
					name: user.name,
					join_date: _gHlp.getCurrentDateTime(),
					is_admin: 0
				})
				this.selected_user_id = null
				this.pushToParent()
			}
		},
		removeUser(item) {
			this.tableData = this.tableData.filter(o => o.id != item.id)
			this.pushToParent()
		},
		setAsAdmin(item, is_admin) {
			this.tableData = this.tableData.map((o) => {
				if (o.id == item.id) {
					o.is_admin = is_admin;
				}
				return o
			})
			this.pushToParent()
		},
		pushToParent() {
			let prevUserIds = (!_gHlp.isEmpty(this.group) && !_gHlp.isEmpty(this.group.group_participants)) ? this.group.group_participants.map(o => o.participant_user_id) : []
			let listSelectedIds = this.tableData.map(o => o.id)
			let listNewIds = this.tableData.filter(o => !prevUserIds.includes(o.id)).map(o => o.id)
			let listRemoveIds = (!_gHlp.isEmpty(this.group)) ? this.group.group_participants.filter(o => !listSelectedIds.includes(o.participant_user_id)).map(o => o.participant_user_id) : []

			let prevUserAdminIds = (!_gHlp.isEmpty(this.group.group_participants)) ? this.group.group_participants.filter(x => x.gmp_is_admin == 1).map(o => o.participant_user_id) : [];
			let listSelectedAdminIds = this.tableData.filter(o => o.is_admin == 1).map(o => o.id)
			let listNewAdminIds = this.tableData.filter(o => ((o.is_admin == 1) && (!prevUserAdminIds.includes(o.id)))).map(o => o.id)
			let listRemoveAdminIds = (!_gHlp.isEmpty(this.group)) ? this.group.group_participants.filter(o => ((o.gmp_is_admin == 1) && (!listSelectedAdminIds.includes(o.participant_user_id)))).map(o => o.participant_user_id) : []

			let params = {
				listSelectedIds: listSelectedIds,
				listNewIds: listNewIds,
				listRemoveIds: listRemoveIds,
				listSelectedAdminIds: listSelectedAdminIds,
				listNewAdminIds: listNewAdminIds,
				listRemoveAdminIds: listRemoveAdminIds
			}

			this.$emit('update', params);
		},
		showRemoveBtn(item) {
			return !this.defaultAdminUserIds.includes(item.id);
		},
		async populateDefaultAdminUserIds() {
			this.defaultAdminUserIds = await _gAuth.activeCorpMsgGroupDefaultAdminIds();
		}
	}
}
</script>